/** Build dialer country-code options from agentCountryCodeDirections (login / Storage). */
export function parseAgentCountryDirectionOptions(agentCountryCodeDirections) {
  if (!Array.isArray(agentCountryCodeDirections)) return [];

  const seen = new Set();
  const options = [];

  agentCountryCodeDirections.forEach((row) => {
    if (!row || row.is_deleted === true) return;
    const master = row.directionMaster;
    if (!master || master.is_deleted === true) return;

    const cc = master.country_code;
    const calling = String(cc?.calling_code ?? "")
      .trim()
      .replace(/^\+/, "");
    if (!calling) return;

    const id = String(row.country_code_direction_id ?? master.id ?? row.id);
    if (seen.has(id)) return;
    seen.add(id);

    options.push({
      id,
      callingCode: calling,
      display: `+${calling}`,
    });
  });

  return options;
}
